/* 中文词典：render 命名空间。见 src/i18n/README.md。 */

import type { TextSpec } from '../text';

const render = {
  // ---- 卡牌分类字样（画在牌面上，单据 / 兜底 / 无效 / 异常几张共用） ----
  'render.category.attack': [ '攻击' ],
  'render.category.lethal': [ '致命' ],
  'render.category.rescue': [ '救命' ],
  'render.category.interrupt': [ '打断' ],
  'render.category.powerless': [ '无效' ],
  'render.category.needsTarget': [ '需目标' ],
  'render.category.function': [ '功能' ],
  // ---- 异常牌面 ----
  'render.face.exceptionHolder': [ '抽到此牌者' ],
  // ---- 濒死正中那张致命牌的 lore 尾巴 ----
  'render.dyingLethalLore': [ '若无人为你打出[捕获]，你将出局。' ],
  // ---- 回合队列 ----
  'render.turnQueue.handCount': [ { type: 'param', name: 'n' }, ' 张' ],
  'render.turnQueue.pointIt': [ '◂ 点击' ],
  // ---- 记牌器状态图例 ----
  'render.legend.discarded': [ '弃牌堆' ],
  'render.legend.inHand': [ '手牌' ],
  'render.legend.unknown': [ '其他' ],
  // ---- 塞回异常时的功能提示 ----
  'render.insertHint.title': [ '塞回位置' ],
  'render.insertHint.drawsUntil': [ '接下来第 ', { type: 'param', name: 'n' }, ' 张被抽到' ],
  'render.insertHint.drawerUnknown': [ '若无人洗牌，抽牌人未知' ],
  'render.insertHint.drawerNamed': [ '若无人洗牌 → ', { type: 'param', name: 'name' } ],
  // ---- CardView / 牌面缓存（内部断言） ----
  'render.cardView.textureTooSmall': [ '牌面纹理 ', { type: 'param', name: 'texW' }, '×', { type: 'param', name: 'texH' }, ' 比牌本身 ', { type: 'param', name: 'sizeW' }, '×', { type: 'param', name: 'sizeH' }, ' 还小 —— 尺寸传反了？' ],
  'render.cardView.textureResized': [ 'CardView 换牌面时纹理尺寸变了（期望 ', { type: 'param', name: 'expectW' }, '×', { type: 'param', name: 'expectH' }, '，拿到 ', { type: 'param', name: 'texW' }, '×', { type: 'param', name: 'texH' }, '）—— 尺寸变了就必须重建 CardView。' ],
  'render.faceCache.badAspect': [ '牌面尺寸 ', { type: 'param', name: 'w' }, '×', { type: 'param', name: 'h' }, ' 不是通用卡牌比例 —— 牌面画法不许自己决定形状，请用 metrics.faceSize()。' ],
  // ---- 动画步进器（内部告警） ----
  'render.motion.error': [ '[motion] 一个动画抛了异常，已把它从每帧队列里摘掉' ],
  // ---- 卡牌渲染试验台（调试页） ----
  'render.lab.emptyPack': [ '原版包里一张牌都没有' ],
  'render.lab.title': [ '象牙轮盘 ivory-roulette' ],
  'render.lab.subtitle': [ '卡牌渲染试验台 · 假透视参数对照（静态演示，还没有参数控制）' ],
  'render.lab.row.yaw': [ 'yaw —— 绕 Y 轴转（水平梯形）：正值右边向后倒' ],
  'render.lab.row.pitch': [ 'pitch —— 绕 X 轴转（垂直梯形）：正值上边向后倒' ],
  'render.lab.row.perspective': [ 'perspective —— 相机距离（以长边为单位）：越小越夸张（角度固定 pitch 0.45）' ],
  'render.lab.row.combo': [ 'combo —— roll + pitch 一起用：手牌扇形（r = roll，p = pitch）' ],
  'render.lab.footer': [ '每行只变一个参数 · 牌面缓存 ', { type: 'param', name: 'cached' }, ' 张 FBO（不是每张牌一张）· 牌面 ', { type: 'param', name: 'w' }, '×', { type: 'param', name: 'h' } ],
  'render.lab.stage.field': [ '① 标量场（未映射）' ],
  'render.lab.stage.mapped': [ '① 标量场 + 映射' ],
  'render.lab.stage.halftone': [ '① + ② 半调（全开）' ],
  'render.lab.hint': [ { type: 'param', name: 'stage' }, ' · 点击扔水波纹（Shift = 涡旋）· 空格随机 · 1/2/3 切阶段 · D 濒死' ],
} as const;

// 静态检查（写在对象字面量之外，避免 TextKey 循环推断）
render satisfies Record<string, TextSpec>;
export default render;
